import { render, staticRenderFns } from "./completeProfile2.vue?vue&type=template&id=97b6f60e&scoped=true&"
import script from "./completeProfile2.vue?vue&type=script&lang=js&"
export * from "./completeProfile2.vue?vue&type=script&lang=js&"
import style0 from "./completeProfile2.vue?vue&type=style&index=0&id=97b6f60e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b6f60e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VProgressLinear})
